import React from "react"
import AuthLayout from "layout/AuthLayout"
import { MainContainer } from "globalStyles"
import { VerifyNINForm } from "components/Dashboard/Profile/VerifyNinForm"

export const VerifyNINPage = () => {
	return (
		<AuthLayout>
			<MainContainer>
				<VerifyNINForm />
			</MainContainer>
		</AuthLayout>
	)
}

